export const DISABLE_CHARGE_WARNING = '/api/payment/disable-charge-warning';

export const GET_USER_CREDIT_CARD_EULA = 'api/payment/get-user-card-eula';

export const ACCEPT_CARD_EULA = 'api/payment/accept-card-eula';
export const REJECT_CARD_EULA = 'api/payment/reject-card-eula';

// export const GET_LINK_IFRAME_CARD = '/api/payment/add-card';
export const GET_LINK_IFRAME_CARD = '/api/payment/get-add-card-iframe-url';

export const IFRAME_COMMUNICATOR = '/api/payment/communicator';

export const SYNC_SAVED_MEMBER_CARD = '/api/payment/sync-payment-profiles';

export const GET_SAVED_MEMBER_CARD = '/api/payment/get-member-saved-cards';

export const REMOVE_SAVED_CARD = '/api/payment/remove-card';

export const GET_LINK_IFRAME_EDITED_CARD = '/api/payment/edit-card';

export const GET_MEMBER_BILLING_PROPERTIES =
  '/api/payment/get-member-billing-properties';

export const SAVE_MEMBER_BILLING_PROPERTIES =
  '/api/payment/save-member-billing-properties';

export const EDIT_MEMBER_PAYMENT_SETTING =
  '/api/payment/edit/edit-payment-setting';

export const GET_MEMBER_BILLING_STATEMENTS =
  '/api/payment/get-member-billing-statements';
export const GET_MEMBER_BILLING_STATEMENTS_DISTINCT =
  '/api/payment/get-member-billing-statements/distinct';

export const ADD_CHARGE = '/api/payment/add-billing-charge';

export const DOWNLOAD_BILLING_STATEMENT =
  '/api/payment/download-member-billing-charges';
export const EXPORT_BILLING_STATEMENT = '/api/payment/download-invoice-summary';

export const GET_AUTHORIZED_CARD_USERS =
  '/api/payment/get-authorized-card-users';
export const GET_NON_AUTHORIZED_CARD_USERS =
  '/api/payment/get-non-authorized-card-users';
export const SAVE_AUTHORIZED_CARD_USER = '/api/payment/authorize-card-user';
export const REMOVE_AUTHORIZED_CARD_USER =
  '/api/payment/remove-authorized-card-user';

export const DOWNLOAD_BILLING_RECEIPT = '/api/payment/download-invoice-summary';

export const GET_INVOICE_DOCUMENT = '/api/payment/get-invoice-document';
export const ADD_BILLING_NOTE = '/api/payment/add-billing-note';
export const GET_BILLING_NOTE_GRID = '/api/payment/get-billing-note-grid';

export const SAVE_MEMBER_DISCOUNT_PROPERTIES =
  '/api/payment/save-member-discount-properties';
export const GET_MEMBER_DISCOUNT_PROPERTIES =
  '/api/payment/get-member-discount-properties';
